import type { LoadedDocument } from "@minga/protocol"
import { versionsOf } from "./outputs"
import type { Artifact, ProjectState } from "./types"

/** Freeze the stored document's provenance for an input or returned result. */
export const workDocumentRefOf = (
  state: Pick<ProjectState, "artifacts">,
  artifact: Artifact,
): LoadedDocument | null => {
  if (!artifact.doc || !artifact.sha256) return null
  return {
    artifactId: artifact.id,
    ref: artifact.ref ?? null,
    path: artifact.doc.path,
    revision: versionsOf(state, artifact).length,
    sha256: artifact.sha256,
    by: artifact.createdBy,
    reason: "linked_document",
    tainted: artifact.tainted,
    ...(artifact.doc.sourceRevision ? { sourceRevision: artifact.doc.sourceRevision } : {}),
  }
}
